/**
 * Formats an unread-style count for a small badge, clamping anything above
 * `max` to `"<max>+"` so the pip keeps a fixed width.
 *
 * Returns `null` when there is nothing to show (zero or negative), letting
 * callers skip rendering entirely rather than paint an empty pip. Fractional
 * counts are floored so a stray `2.7` reads as `2` instead of overflowing the
 * pip.
 *
 * @example formatNotificationCount(3) // "3"
 * @example formatNotificationCount(9) // "9"
 * @example formatNotificationCount(10) // "9+"
 * @example formatNotificationCount(0) // null
 */
export default function formatNotificationCount(count: number, max = 9): string | null {
  if (!Number.isFinite(count)) {
    return null;
  }

  const whole = Math.floor(count);
  if (whole <= 0) {
    return null;
  }

  return whole > max ? `${max}+` : String(whole);
}
